<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">BOGO</span>
    </template>
    <b-container>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save BOGO
        </b-button>
        <b-button
          variant="primary"
          @click="addNewForm"
        >
          <span>Add new BOGO config</span>

        </b-button>
      </div>

      <validation-observer
        v-for="(el, index) in bogoArr"
        :key="el.localId"
        :ref="`bogoRef-${el.localId}`"
      >
        <b-form>
          <b-row class="pb-5 bonus_form_style">
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteForm(index)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>

            <b-col md="4">
              <validation-provider
                name="From Time"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From Time"
                  :label-for="`from-time-${el.localId}`"
                >
                  <b-form-input
                    :id="`from-time-${el.localId}`"
                    v-model="el.from_time"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="4">
              <validation-provider
                name="To Time"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To Time"
                  :label-for="`to-time-${el.localId}`"
                >
                  <b-form-input
                    :id="`to-time-${el.localId}`"
                    v-model="el.to_time"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="4">
              <b-form-group label="Auto Apply">
                <b-form-checkbox
                  :id="`auto-apply-${el.localId}`"
                  v-model="el.auto_apply"
                  switch
                >
                  Auto Apply
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Code"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Code"
                  :label-for="`code-${el.localId}`"
                >
                  <b-form-input
                    :id="`code-${el.localId}`"
                    v-model="el.code"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Promo Code"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Promo Code"
                  :label-for="`promo-code-${el.localId}`"
                >
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      BOGO_
                    </b-input-group-prepend>
                    <b-form-input
                      :id="`promo-code-${el.localId}`"
                      v-model="el.promo_code"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Notification Title (Arabic)"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Notification Title (Arabic)"
                  :label-for="`notification-ar-title-${el.localId}`"
                >
                  <b-form-input
                    :id="`notification-ar-title-${el.localId}`"
                    v-model="el.notification.arabic.title"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Notification Description (Arabic)"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Notification Description (Arabic)"
                  :label-for="`notification-ar-desc-${el.localId}`"
                >
                  <b-form-input
                    :id="`notification-ar-desc-${el.localId}`"
                    v-model="el.notification.arabic.description"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Notification Title (English)"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Notification Title (English)"
                  :label-for="`notification-en-title-${el.localId}`"
                >
                  <b-form-input
                    :id="`notification-en-title-${el.localId}`"
                    v-model="el.notification.english.title"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                name="Notification Description (English)"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Notification Description (English)"
                  :label-for="`notification-en-desc-${el.localId}`"
                >
                  <b-form-input
                    :id="`notification-en-desc-${el.localId}`"
                    v-model="el.notification.english.description"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <MapPolygonDrawer
                :map-id="`polygon-drawer-${el.localId}`"
                :initial-coords="el.target"
                @path-set="coords => el.target = coords"
              />
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BButton, BFormGroup, BForm, BFormCheckbox,
  BInputGroupPrepend,
  BInputGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { tripStates } from '../../hooks/useStaticOptions'
import { errorNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'
import MapPolygonDrawer from '../MapPolygonDrawer.vue'

const BOGO_PREFIX = 'BOGO_'

export default {
  components: {
    BTab,
    MapPolygonDrawer,
    BFormCheckbox,
    BContainer,
    BInputGroupPrepend,
    BInputGroup,
    BRow,
    BCol,
    BFormInput,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BForm,
  },
  props: {
    bogoArray: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const bogoArr = ref([...props.bogoArray.map(el => ({ ...el, localId: Math.random().toString(), promo_code: el.promo_code.split(BOGO_PREFIX)[1] }))])

    const addNewForm = () => {
      const tempConfig = {
        localId: Math.random().toString(),
        from_time: '',
        to_time: '',
        auto_apply: false,
        code: '',
        promo_code: '',
        notification: {
          arabic: {
            title: '',
            description: '',
          },
          english: {
            title: '',
            description: '',
          },
        },
        target: [],
      }
      bogoArr.value.unshift(tempConfig)
    }
    const deleteForm = index => {
      bogoArr.value.splice(index, 1)
    }

    const validateForm = async () => {
      console.log(bogoArr.value, 'bogoArr.value')
      const bogoArrTemp = bogoArr.value.map(el => ({
        ...el,
        promo_code: `${BOGO_PREFIX}${el.promo_code}`,
      }))
      console.log(bogoArrTemp, 'bogoArrTemp')
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('set', bogoArrTemp)
        ctx.emit('applied', bogoArrTemp)
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      validateForm,
      addNewForm,
      deleteForm,
      bogoArr,
    }
  },
}
</script>

  <style scoped>
  .bonus_form_style{
      border: 3px solid lightgray;
      padding: 20px;
      margin-bottom: 30px;
      border-radius: 20px;
  }
  </style>
